import * as dayjs from "dayjs";

export default (date?: Date): Date | undefined => {
    if (date)
        return dayjs(date).toDate();
    else
        return undefined;
};